import TrashCan from "@assets/images/trash.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

interface BottomBarProps {
  selectedLine: number;
  disabled: boolean;
  disabledDelete?: boolean;
  onClick: () => void;
  onSubmit: () => void;
}

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  () => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)",
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    btnOrder: {
      marginLeft: 20
    },
    btnDelete: {
      marginRight: 16,
      padding: "12px"
    },
    colorIconTrash: {
      "& path": {
        stroke: "#FF2600",
        strokeWidth: "2"
      }
    },
    colorDisableIcon: {
      "& path": {
        stroke: "#CCCCCC",
        strokeWidth: "2"
      }
    }
  }),
  { name: "BottomBar" }
);

const BottomBar: React.FC<BottomBarProps> = ({
  selectedLine,
  disabled,
  disabledDelete,
  onSubmit,
  onClick
}) => {
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });

  return (
    <div className={classes.bottomBar}>
      <div>
        <Button
          id="deleteItems"
          variant={"outlined"}
          color={"primary"}
          onClick={onClick}
          className={classes.btnDelete}
          disabled={disabledDelete}
        >
          <SVG
            src={TrashCan}
            className={
              disabledDelete ? classes.colorDisableIcon : classes.colorIconTrash
            }
          />
          <MyTypography component="span" variant="body2" color="inherit">
            <FormattedMessage defaultMessage={"ลบรายการที่เลือก"} /> (
            <b>{selectedLine}</b>)
          </MyTypography>
        </Button>
      </div>
      <div className={classes.barRight}>
        <MyTypography variant="body2">
          เลือก <b>{selectedLine}</b> รายการ
        </MyTypography>
        <div className={classes.btnOrder}>
          <Button
            id="createOrder"
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onSubmit}
          >
            <b>
              <FormattedMessage defaultMessage={"สร้างคำสั่งซื้อ"} />
            </b>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
